import { APICore } from './apiCore'

const api = new APICore()

function getDestinos (params) {
  const baseUrl = '/destinos'
  return api.get(baseUrl, params)
}

function getDestino (id) {
  const baseUrl = `/destinos/${id}`
  return api.get(baseUrl, {})
}

function addDestino (params) {
  const baseUrl = '/destinos'
  return api.create(baseUrl, params)
}

function updateDestino (params) {
  const baseUrl = '/destinos'
  return api.update(baseUrl, params)
}

function deleteDestino (params) {
  const baseUrl = '/destinos'
  return api.delete(baseUrl, params)
}

export { getDestinos, getDestino, addDestino, updateDestino, deleteDestino }
